import script from "./Recordings.vue?vue&type=script&setup=true&lang=js"
export * from "./Recordings.vue?vue&type=script&setup=true&lang=js"

import "./Recordings.vue?vue&type=style&index=0&id=7c2e46b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c2e46b6"]])

export default __exports__